<template>
  <div class="container container-fluid mt-4 mb-4">

    <status-logs-list-filters v-model="params" />

    <c-data-list :items="statusLogs" @load="load" class="list-data no-links list-data-xs-full">
      <template #columns>
        <div class="col-lg-3">Start Time</div>
        <div class="col-lg-3">End Time</div>
        <div class="col-lg-3">Duration</div>
        <div class="col-lg-3">Type</div>
      </template>

      <template #default="{ item }">
        <status-logs-list-item :log="item" />
      </template>
    </c-data-list>
  </div>
</template>

<script>
import { compareQueryParams } from '@codium/codium-vue'
import { helperComputed, helperMethods } from '@/vuex/modules/screens/status-logs'
import StatusLogsListItem from './StatusLogsListItem'
import StatusLogsListFilters from './StatusLogsListFilters'

export default {
  components: {
    StatusLogsListItem,
    StatusLogsListFilters
  },

  data () {
    return {
      params: null
    }
  },

  watch: {
    params: compareQueryParams(async function (params) {
      await this.getStatusLogs({ params, fresh: true })
    })
  },

  computed: {
    ...helperComputed
  },

  beforeDestroy () {
    this.resetStatusLogs()
  },

  methods: {
    ...helperMethods,

    async load (done) {
      const { params } = this

      try {
        await this.getStatusLogs({ params })

        done()
      } catch {
        done(true)
      }
    }
  }
}
</script>
